import replace from "../helpers/replace";
import decodeHtml from "../helpers/decode";
import printAuthor from "../helpers/authors";
import defaults from "../helpers/defaults";

function Card(hit) {
	if (hit._highlightResult && hit._highlightResult.post_title && hit._highlightResult.post_title.value) {
		hit._highlightResult.post_title.value = decodeHtml(hit._highlightResult.post_title.value);
	}

	let blog_id = hit.blog_id;
	if ( ! blog_id ) {
		blog_id = 2;
	}

	let image = hit.images['cap-500'] && hit.images['cap-500'].url;
	image = replace(image);
	let imageAlt = hit.images['cap-500'] && hit.images['cap-500'].alt;
	
	if ( ! image || undefined === image ) {
		if ( hit.post_type === 'person' ) {
			image = defaults.images[blog_id][hit.post_type];
			imageAlt = 'Person placeholder avatar';
		} else {
			image = defaults.images[blog_id]['other'];
			imageAlt = 'The Center for American Progress logo';
		}
	}

	let formattedDate = hit.post_date_formatted;

	const is_external = ! hit.permalink.includes('progress');
	image = is_external ? '' : image;

	// authors
	let authorString = '';
	if (Array.isArray(hit.authors) && hit.authors.length) {
		authorString = hit.authors.map((author, index) => {
			let singleAuthor = '';
			if ( 3 === index && hit.authors.length > 3 ) {
				singleAuthor = `<a href="#" class="readmore1" x-data="" @click.prevent="setTimeout(function(){ window.dispatchEvent(new CustomEvent('recalculate')); },10); $el.remove();" clickable="" scripted=""><i class="icon-plus-medium"></i><span>${hit.authors.length - index} More</span></a>`;
			}
			singleAuthor += printAuthor(author);
			if ( index < hit.authors.length - 1 && hit.authors.length > 1 ) {
				singleAuthor += '<span>, </span>';
			}
			return singleAuthor;
		}).join(' ');
	}

	// Kicker
	let kickerText = hit.post_type_label;
	switch ( hit.post_type ) {
		case 'event':
			// TODO: if is past, kickerText = 'Past Event';
			break;
		case 'press':
			kickerText = hit.taxonomies.press_type ? hit.taxonomies.press_type[0] : 'press';
			break;
		case 'article':
			kickerText = hit.taxonomies.article_type ? hit.taxonomies.article_type[0] : 'article';
			break;
	}

	// Event Icon
	let icon = '';
	if ( hit.post_type === 'event' ) {
		if ( hit.length && hit.event_meta.attendance_method.length && hit.event_meta.attendance_method.includes('VirtualLocation') && hit.event_meta.attendance_method.includes('Place') ) {
			icon = '<i class="icon-figure icon-event-hybrid"></i>';
		} else if ( hit.length && hit.event_meta.attendance_method.length && hit.event_meta.attendance_method.includes('VirtualLocation') ) {
			icon = '<i class="icon-figure icon-event-online"></i>';
		} else {
			icon = '<i class="icon-figure icon-event-inperson"></i>';
		}
	}

	let video_icon = '';
	let has_video = hit.has_video ? true : '';
	if ( has_video) {
		video_icon = '<i class="card2-video icon-triangle-right "></i>';
	} 

	const permalink = replace(hit.permalink);

	return `
	<article class="card2 -v2 -sep">
		<div class="card2-wrap">
			<a href="${permalink}" class="card2-link -as:1" adjacent="">
				<span invisible="">${hit.post_title}</span>
			</a>
			<span class="label1 -t:16"><span class="label1-main">${kickerText}</span>
				${has_video && `
					<i class="label1-icon icon-triangle-right"></i>
				`}
				<span class="-t:21">
					<time datetime="">${formattedDate}</time>
				</span>
			</span>	
			${image && `
				<figure class="card2-image">
					<span class="line1"></span>
					${video_icon}
					<span class="img1 -top" style="--rl: 0.66987951807229">
						${icon}
						<img src="${image}?w=500" alt="${imageAlt}" />
					</span>
				</figure>`
			}
			<div class="card2-main">
				<div class="card2-header">
					<div class="card2-inner" equalize="">
						<h4 class="card2-title -t:3 -t:6<m"><span class="-hs:1">${instantsearch.highlight({ attribute: 'post_title', hit })}</span></h4>
						<p class="card2-excerpt -t:12">${instantsearch.snippet({ attribute: 'content', hit })}</p>
					</div>
				</div>
				<div class="card2-meta -t:9 -as:2 ">
					<p class="card2-date">
						<span>
							<time class="" datetime="">${formattedDate}</time>
						</span>
					</p>
					<p class="card2-authors">
						${authorString}
					</p>
				</div>
			</div>
		</div>
	</article>
	`;
}

export default Card;
